import { EntityType } from '@communities/content-management/domain';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { TraitsSection } from '@moderation/components/TraitsSection';
import { Section } from '@soteria/design-system-ve';

import * as styles from './ClassificationTab.css';
import { ModerationActionsTab } from './ModerationActionsTab';
import { TopicsTab } from './TopicsTab';

interface ModerationTabProps {
  communityId: string;
  isEntityAdmin: boolean;
}

/**
 * Moderation tab component for community management
 * Provides access to moderation tools including traits management, topics, and actions
 */
function ModerationTabComponent({ communityId, isEntityAdmin }: ModerationTabProps) {
  return (
    <div className={styles.tabContainer}>
      {/* Moderation Topics Settings Section */}
      <TopicsTab
        showModerationSettings
        entityId={communityId}
        entityType={EntityType.COMMUNITY}
        isEntityAdmin={isEntityAdmin}
        sectionTitle="Moderation Topics Settings"
      />

      {/* Traits Section */}
      <Section spacing="large">
        <TraitsSection />
      </Section>

      {/* Moderation Actions Section */}
      <ModerationActionsTab entityId={communityId} entityType={EntityType.COMMUNITY} isEntityAdmin={isEntityAdmin} sectionTitle="Moderation Actions" />
    </div>
  );
}

export const ModerationTab = withAppInsightsTracking(ModerationTabComponent, 'ModerationTab');
